import api from './axios';

// Employee: list my CV reviews for selected review type
export async function listMyCompanyValueReviews(reviewTypeId) {
    const { data } = await api.get('/api/company-value-reviews/mine', {
        params: { review_type_id: reviewTypeId },
    });
    return data; // { contract, review_type_id, data:[{company_value:{...}, review:{...}}] }
}

// Manager: list CV reviews for a chosen employee
export async function listManagedCompanyValueReviews(reviewTypeId, employeeId) {
    const { data } = await api.get('/api/company-value-reviews/managed', {
        params: { review_type_id: reviewTypeId, employee_id: employeeId },
    });
    return data;
}

// Employee update
export async function updateCompanyValueReviewEmployee(id, payload) {
    const { data } = await api.put(`/api/company-value-reviews/${id}`, payload);
    return data;
}

// Manager update
export async function updateCompanyValueReviewManagerV1(id, payload) {
    const { data } = await api.put(`/api/company-value-reviews/${id}/manager`, payload);
    return data;
}


function normalizeRow(row) {
    // Expect shape:
    // {
    //   company_value: { id, name, weight },
    //   review: { id?, employee_rating_id?, employee_description?, employee_comment?, manager_rating_id?, manager_description?, manager_comment? }
    // }
    const cv = row.company_value || {};
    const rv = row.review || {};
    return {
        companyValue: {
            id: cv.id,
            name: cv.name,
            weight: cv.weight,
        },
        review: {
            id: rv.id ?? null,
            employee_rating_id: rv.employee_rating_id ?? null,     // SCORE
            employee_description: rv.employee_description ?? '',    // CODE
            employee_comment: rv.employee_comment ?? '',
            manager_rating_id: rv.manager_rating_id ?? null,        // SCORE
            manager_description: rv.manager_description ?? '',      // CODE
            manager_comment: rv.manager_comment ?? '',
        }
    };
}

/**
 * GET company-value reviews for "me" (employee) in a review type
 * Server infers my active contract.
 */
export async function listMineCompanyValueReviews(reviewTypeId) {
    const { data } = await api.get('/api/company-value-reviews', {
        params: { review_type_id: reviewTypeId }
    });
    // Optionally ratings are included; otherwise fetch via /performance-ratings
    const rows = Array.isArray(data?.data) ? data.data : [];
    return {
        rows: rows.map(normalizeRow),
        ratings: data?.ratings || null, // [{id, score, code, name}]
        contract: data?.contract || null
    };
}

/**
 * GET company-value reviews for a specific employee (manager view)
 */
export async function listEmployeeCompanyValueReviews(reviewTypeId, employeeId) {
    const { data } = await api.get('/api/company-value-reviews', {
        params: { review_type_id: reviewTypeId, employee_id: employeeId }
    });
    const rows = Array.isArray(data?.data) ? data.data : [];
    return {
        rows: rows.map(normalizeRow),
        ratings: data?.ratings || null,
        contract: data?.contract || null
    };
}

/**
 * Employee upsert (create/update) a review row.
 * payload: { contract_id, review_type_id, company_value_id, employee_rating_id, employee_comment }
 */
export async function upsertCompanyValueReviewEmployee(payload) {
    const { data } = await api.post('/api/company-value-reviews', payload);
    return data; // returns the updated/created review
}

/**
 * Manager update of a review row.
 * patch: { manager_rating_id, manager_comment }
 */
export async function updateCompanyValueReviewManager(reviewId, patch) {
    const { data } = await api.put(`/api/company-value-reviews/${reviewId}/manager`, patch);
    return data; // updated review
}

/** Fallback ratings if backend doesn’t inline them */
export async function fetchPerformanceRatings() {
    const { data } = await api.get('/api/performance-ratings');
    // normalize to [{id, score, code, name}]
    return (data?.data || data || []).map(r => ({
        id: r.id,
        score: r.score ?? r.id, // prefer score; fallback id
        code: r.code,
        name: r.name
    }));
}